module.exports = __webpack_public_path__ + "img/tu06.a4017c4b.jpg";